import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ModalElementProps, ModalFormElementProps } from 'framework/modal/types';

const fade_in = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const ModalElement = styled.div<ModalElementProps>`
  background: ${({ theme }) => theme.general.backdrop};
  visibility: ${({ is_visible }) => (is_visible ? 'visible' : 'hidden')};
  animation: ${fade_in} ${({ duration }) => duration}ms ease;
  opacity: ${({ is_visible }) => (is_visible ? 1 : 0)};
`;

export const ModalFormElement = styled.form<ModalFormElementProps>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  gap: ${({ gap }) => gap};
  padding: ${({ theme }) => theme.general.padding};
  margin: ${({ theme }) => theme.general.margin};
  border-radius: ${({ theme }) => theme.general.border_radius};
  background: ${({ theme }) => theme.background.normal};
  border: ${({ theme }) => theme.border.normal};
`;
